// extracted by mini-css-extract-plugin
export default {"table_text":"SelectDeviceModal_table_text__Et74V"};